var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHabitsNone = function SvgHabitsNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M40 49.007 15.714 73.293l-9.007-9.007L30.993 40 6.707 15.714l9.007-9.007L40 30.993 64.286 6.707l9.007 9.007L49.007 40l24.286 24.286-9.007 9.007z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "m15.714 7.414 23.578 23.578.708.708.707-.707L64.286 7.414l8.3 8.3-23.579 23.579L48.3 40l.707.707 23.578 23.579-8.3 8.3-23.578-23.579L40 48.3l-.707.707-23.579 23.579-8.3-8.3 23.579-23.579L31.7 40l-.707-.707L7.414 15.714l8.3-8.3M64.286 6 40 30.286 15.714 6 6 15.714 30.286 40 6 64.286 15.714 74 40 49.714 64.286 74 74 64.286 49.714 40 74 15.714 64.286 6z"
  })));
};

export default SvgHabitsNone;